import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';

import { MethodProps } from '../types';
import { useI18n } from '~Hooks';
import { useStorage } from '~Components/Storage';
import NumberInput from '~ComponentsImproved/Numpad';
import Retain24Payment from '~Components/Retain24';

const Retain24: React.FunctionComponent<MethodProps> = ({
  payment,
  amount,
  onMetaChange,
  onComplete,
  onFail,
}) => {
  const [storage] = useStorage();
  const { i18n } = useI18n();
  const [showTipModal, setShowTipModal] = useState(!payment.disableTip || storage.enableTipping);

  function onFailAndClose() {
    onFail();
  }

  // If the payment that spawned this is completed, don't render this
  if (payment.status === 'COMPLETED') {
    return null;
  }

  if (showTipModal) {
    return (
      <NumberInput
        key="tip"
        initialValue={'0'}
        decimal
        title={i18n('TM.Tip')}
        onSubmit={(tipAmount) => {
          setShowTipModal(false);

          // Ensure input is valid
          const tip = parseFloat(tipAmount);
          if (isNaN(tip)) {
            onFail();
            return;
          }

          // Set amount to total including tip
          onMetaChange({ tip: tip * 100 });

          // Go on to microdeb payment
          // Slight delay so meta has time to update
          setTimeout(() => setShowTipModal(false), 1000);
        }}
        onClose={() => {
          setShowTipModal(false);
          onFail(i18n('Payment.Canceled'));
        }}
      />
    );
  }

  const tip = payment.meta.tip;
  return (
    <Retain24Payment
      id={`r24_${uuid()}`}
      amount={amount! + (tip ?? 0)}
      onFail={onFailAndClose}
      onComplete={(transactionId) =>
        onComplete(null, {
          transactionId,
        })
      }
      type="PAYMENT"
    />
  );
};

export default Retain24;
